import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-102efc8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "show-info-title" }, "问题描述", -1))
const _hoisted_3 = { class: "show-info-lable" }
const _hoisted_4 = {
  key: 0,
  class: "img-list"
}
const _hoisted_5 = { class: "img-item" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.myquestion.content), 1),
      (
          _ctx.myquestion.pics &&
          _ctx.myquestion.pics != 'null' &&
          _ctx.myquestion.pics.length > 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myquestion.pics, (pic, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", { src: pic }, null, 8, _hoisted_6)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}